import { Button, Collapse, Divider, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import updateHistory from "./utils/updateHistory"
import { HasId, ID } from "src/libs/interfaces/layouts"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useState } from "react"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"

/* Protopia Ecosystem component */
export interface ICompositionWidgetProps {
   sectionId: ID
}
const CompositionWidget = ({sectionId, ...props}: ICompositionWidgetProps): JSX.Element => {
    const currentLanding                = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section                       = currentLanding.sections.find( (section: HasId) => section.id === sectionId )
    const composition                   = useComposition(section)
    const [designType, setDesignType]   = useState<SECTION_DESIGN_TYPE>( section.designType || SECTION_DESIGN_TYPE.FEED )
    const [isOpen, setIsOpen]           = useState<boolean>( false )

    const onOpen = () => {
        setIsOpen(!isOpen)
    }
    const onClick = (type: SECTION_DESIGN_TYPE) => {
        const prevData          = JSON.parse( JSON.stringify( section ) )
        const newSection: any   = { 
            ...section, 
            designType: type,
        } 
        const historyStep: IHistoryStep = {
            data:  newSection,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title : "Update section's design type",
        }
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec: ILandingSection) => {
                if(sec.id === sectionId ) {
                    return newSection
                }
                return sec
            })
        }  
        updateHistory( historyStep, newLanding ) 
        setDesignType( type )
    }
    return section.data.length > 1
        ?
        <>
            <div className="p-2"> 
                <div className="text-nowrap w-100 d-flex">
                    { __( "Current design type" ) }: 
                    <span className="title ml-2 text-wrap">{__( designType )}</span>
                    <Button 
                        variant="minimal" 
                        size="small" 
                        className="ml-auto"
                        icon={ `chevron-${ isOpen ? "up" : "down" }` }  
                        onClick={ onOpen } 
                    />
                </div>
                <Collapse isOpen={isOpen} className="w-100">
                    <div className=" pt-2 d-flex flex-wrap column-4 width-200">
                    {
                        Object.values( SECTION_DESIGN_TYPE ).map( v => {
                            return <div key={v} className="w-25 p-1 mb-1 hover pointer" onClick={ () => onClick( v ) } >
                                <Tooltip
                                    intent="primary"
                                    position="top-left"
                                    content={<div className="small">
                                        { __( v ) } 
                                    </div>}
                                >
                                    <img
                                        alt=""
                                        src={`/assets/img/landing/design_type_${v}.svg`}
                                        width={ 45 }
                                        className={ designType === v ? "" : `opacity_5`}
                                    />
                                </Tooltip> 
                            </div> 
                        })
                    }
                    </div>
                </Collapse>
            
            </div> 
            <Divider  />
        </>
        :
        <></>
}
export default CompositionWidget